module.exports = __webpack_public_path__ + "img/TAUR_BANNER_SOCIAL_YOUTUBE.948eeaa1.jpg";